<template>
  <div>
    <div class="nav-search relative flex flex-wrap mb-3">
      <div class="w-full justify-between flex flex-auto">
        <div>
          <h1
            class="inline-block"
            id="title"
            v-if="
              book && book.title && ($route.query.book || $route.params.note)
            "
          >
            <span
              @click="$router.go(-1)"
              class="cursor-pointer inline-block relative"
              style="top: 4px"
            >
              <Zondicon
                class="w-6 fill-current cursor-pointer"
                icon="CheveronLeft"
              />
            </span>
            <span>
              <router-link :to="`/admin/notes?book=${book.id}`">
                {{ book.title }}
              </router-link>
            </span>
          </h1>
          <h1 class="inline-block" v-else-if="$route.params.note && note">
            <span
              @click="$router.go(-1)"
              class="cursor-pointer inline-block relative"
              style="top: 4px"
            >
              <Zondicon
                class="w-6 fill-current cursor-pointer"
                icon="CheveronLeft"
              />
            </span>
            <span>
              <router-link :to="`/admin/notes?book=${note.book.id}`">
                {{ note.book.name }}
              </router-link>
            </span>
          </h1>
          <h1 class="inline-block" v-else></h1>
        </div>
        <div class="flex">
          <book-actions-menu />
        </div>
      </div>
    </div>

    <div class="relative">
      <div class="search w-full">
        <search-dropdown></search-dropdown>
      </div>
      <recent-notes
        :closeMenu="
          closeOthers =>
            $store.dispatch('aShowRecent', { show: false, closeOthers })
        "
        :get-notes="book_id => $store.dispatch('aGetRecentNotes', book_id)"
        :notes="$store.state.notes.recentNotes"
        key="recent"
        name="recent-notes"
        v-if="showRecent"
      />

      <recent-notes
        :closeMenu="
          closeOthers =>
            $store.dispatch('aShowFavorite', { show: false, closeOthers })
        "
        :get-notes="book_id => $store.dispatch('aGetFavoriteNotes', book_id)"
        :notes="$store.state.notes.favoriteNotes"
        key="favorites"
        name="favorite-notes"
        v-if="showFavorite"
      />
    </div>

    <div v-if="admin_book_search && admin_book_search.category">
      Category: {{ admin_book_search.category.name }}
      <span
        class="close-times cursor-pointer text-2xl leading-none relative text-gray-700"
        v-on:click="clearCategory"
        >&times;</span
      >
    </div>

    <div>
      <div
          class="flex text-blue-darker border border-4 border-blue rounded bg-white mb-5 text-lg"

      >
        <div
            class="p-3 cursor-pointer capitalize w-full"
            title="Add note inline"
            v-on:click="createNote"
        >
          <span>new note</span>
        </div>
        <div
            class="border-l border-blue p-3 cursor-pointer"
            v-on:click="(e) => createNote(e, true)"
        >
          <Zondicon
              class="w-6 fill-current cursor-pointer inline-block relative float-right"
              icon="DocumentAdd"
              style="top: -1px"
          />
        </div>
      </div>
    </div>
    <!-- Popups -->
    <div>
      <unlocker v-if="$store.state.notes.showUnlocker"/>
    </div>
  </div>
</template>

<script>
import SearchDropdown from "./SearchDropdown.vue";
import RecentNotes from "./RecentNotes.vue";
import BookActionsMenu from "./BookActionsMenu";
import OptionsDropdown from "./OptionsDropdown";
import Unlocker from "./Unlocker";

export default {
  components: {
    OptionsDropdown,
    SearchDropdown,
    RecentNotes,
    BookActionsMenu,
    Unlocker,
  },
  methods: {
    async createNote(e, separate = false) {
      // If it's a book,
      let book_id = null;
      let isBookOrNotePage =
          (this.$route.query.book || this.$route.params.note) && this.book;
      if (isBookOrNotePage) {
        book_id = this.book.id;
      } else {
        book_id = this.user.default_book;
      }

      const noteId = await this.$store.dispatch("aCreateNote", book_id);
      // Figure out where to go and where to add this note (inline or go to separate page)
      const isBook = this.$route.query.book && this.book;

      console.log('this.book', this.book, this.user, isBook, separate);

      // If it's a book, we can safely add inline;
      // However, still check if the user wants to go to the standalone
      // Else, just go to the standalone (for ex., if the user is on the home page or a single note page)
      if (isBook) {
        if (separate) {
          this.$router.push({ path: `/admin/notes/${noteId}/update` });
        }
      } else {
        this.$router.push({ path: `/admin/notes/${noteId}/update` });
      }

    },
  },
  // props: ['handleSearchSubmit'],
  computed: {
    book: function() {
      return this.$store.state.notes.book;
    },
    note() {
      // if we are on a single note page, return the single note
      if (this.$route.params.note) {
        const noteId = parseInt(this.$route.params.note);
        const index = this.$store.state.notes.notes.findIndex(
          x => x.id === noteId
        );
        return this.$store.state.notes.notes[index];
      }
      return null;
    },
    admin_book_search() {
      return this.$store.state.notes.admin_book_search;
    },
    showSearch() {
      console.log("showSearch", this.$store.state.notes.showSearch);
      return this.$store.state.notes.showSearch;
    },
    showRecent() {
      return this.$store.state.notes.showRecent;
    },
    showFavorite() {
      return this.$store.state.notes.showFavorite;
    },
    showOptions() {
      return this.$store.state.notes.showOptions;
    },
    user: function() {
      return this.$store.state.notes.user ? this.$store.state.notes.user : false;
    },
  }
};
</script>

<style lang="scss"></style>
